import { render } from "./DatasetWrapper.vue?vue&type=template&id=638f75b5&ts=true"
import script from "./DatasetWrapper.vue?vue&type=script&lang=ts"
export * from "./DatasetWrapper.vue?vue&type=script&lang=ts"

import "./DatasetWrapper.vue?vue&type=style&index=0&id=638f75b5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__